/*!
 * devextreme-angular-test
 * Version: 17.2.8
 * Build date: Mon Feb 05 2018
 *
 * Copyright (c) 2012 - 2018 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */


import {
    Component,
    NgModule,
    Host,
    SkipSelf,
    Input,
    ContentChildren,
    forwardRef,
    QueryList
} from '@angular/core';


import DevExpress from 'devextreme/bundles/dx.all';

import { NestedOptionHost } from '../../core/nested-option';
import { NestedOption } from '../../core/nested-option';
import { DxiBreakComponent } from './break-dxi';



export class DxoScaleComponent extends NestedOption {
    
    get allowDecimals(): boolean {
        return this._getOption('allowDecimals');
    }
    set allowDecimals(value: boolean) {
        this._setOption('allowDecimals', value);
    }

    
    get customMinorTicks(): Array<number> {
        return this._getOption('customMinorTicks');
    }
    set customMinorTicks(value: Array<number>) {
        this._setOption('customMinorTicks', value);
    }

    
    get customTicks(): Array<number> {
        return this._getOption('customTicks');
    }
    set customTicks(value: Array<number>) {
        this._setOption('customTicks', value);
    }

    
    get endValue(): number|
        Date|
        string {
        return this._getOption('endValue');
    }
    set endValue(value: number|
        Date|
        string) {
        this._setOption('endValue', value);
    }

    
    get hideFirstLabel(): boolean {
        return this._getOption('hideFirstLabel');
    }
    set hideFirstLabel(value: boolean) {
        this._setOption('hideFirstLabel', value);
    }

    
    get hideFirstTick(): boolean {
        return this._getOption('hideFirstTick');
    }
    set hideFirstTick(value: boolean) {
        this._setOption('hideFirstTick', value);
    }

    
    get hideLastLabel(): boolean {
        return this._getOption('hideLastLabel');
    }
    set hideLastLabel(value: boolean) {
        this._setOption('hideLastLabel', value);
    }

    
    get hideLastTick(): boolean {
        return this._getOption('hideLastTick');
    }
    set hideLastTick(value: boolean) {
        this._setOption('hideLastTick', value);
    }

    
    get label(): any {
        return this._getOption('label');
    }
    set label(value: any) {
        this._setOption('label', value);
    }

    
    get majorTick(): any {
        return this._getOption('majorTick');
    }
    set majorTick(value: any) {
        this._setOption('majorTick', value);
    }

    
    get minorTick(): any {
        return this._getOption('minorTick');
    }
    set minorTick(value: any) {
        this._setOption('minorTick', value);
    }

    
    get minorTickInterval(): number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number } {
        return this._getOption('minorTickInterval');
    }
    set minorTickInterval(value: number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number }) {
        this._setOption('minorTickInterval', value);
    }

    
    get orientation(): string {
        return this._getOption('orientation');
    }
    set orientation(value: string) {
        this._setOption('orientation', value);
    }

    
    get startValue(): number|
        Date|
        string {
        return this._getOption('startValue');
    }
    set startValue(value: number|
        Date|
        string) {
        this._setOption('startValue', value);
    }

    
    get tick(): any {
        return this._getOption('tick');
    }
    set tick(value: any) {
        this._setOption('tick', value);
    }

    
    get tickInterval(): number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number } {
        return this._getOption('tickInterval');
    }
    set tickInterval(value: number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number }) {
        this._setOption('tickInterval', value);
    }

    
    get horizontalOrientation(): string {
        return this._getOption('horizontalOrientation');
    }
    set horizontalOrientation(value: string) {
        this._setOption('horizontalOrientation', value);
    }

    
    get verticalOrientation(): string {
        return this._getOption('verticalOrientation');
    }
    set verticalOrientation(value: string) {
        this._setOption('verticalOrientation', value);
    }

    
    get breaks(): Array<DevExpress.viz.ScaleBreak|
        { endValue?: Date|
        number|
        string, startValue?: Date|
        number|
        string }> {
        return this._getOption('breaks');
    }
    set breaks(value: Array<DevExpress.viz.ScaleBreak|
        { endValue?: Date|
        number|
        string, startValue?: Date|
        number|
        string }>) {
        this._setOption('breaks', value);
    }

    
    get breakStyle(): any {
        return this._getOption('breakStyle');
    }
    set breakStyle(value: any) {
        this._setOption('breakStyle', value);
    }

    
    get categories(): Array<number|
        string|
        Date> {
        return this._getOption('categories');
    }
    set categories(value: Array<number|
        string|
        Date>) {
        this._setOption('categories', value);
    }

    
    get endOnTick(): boolean {
        return this._getOption('endOnTick');
    }
    set endOnTick(value: boolean) {
        this._setOption('endOnTick', value);
    }

    
    get holidays(): Array<Date|
        string|
        number> {
        return this._getOption('holidays');
    }
    set holidays(value: Array<Date|
        string|
        number>) {
        this._setOption('holidays', value);
    }

    
    get logarithmBase(): number {
        return this._getOption('logarithmBase');
    }
    set logarithmBase(value: number) {
        this._setOption('logarithmBase', value);
    }

    
    get majorTickInterval(): number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, seconds?: number, years?: number } {
        return this._getOption('majorTickInterval');
    }
    set majorTickInterval(value: number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, seconds?: number, years?: number }) {
        this._setOption('majorTickInterval', value);
    }

    
    get marker(): any {
        return this._getOption('marker');
    }
    set marker(value: any) {
        this._setOption('marker', value);
    }

    
    get maxRange(): number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number } {
        return this._getOption('maxRange');
    }
    set maxRange(value: number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number }) {
        this._setOption('maxRange', value);
    }

    
    get minorTickCount(): number {
        return this._getOption('minorTickCount');
    }
    set minorTickCount(value: number) {
        this._setOption('minorTickCount', value);
    }

    
    get minRange(): number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number } {
        return this._getOption('minRange');
    }
    set minRange(value: number|
        string|
        { days?: number, hours?: number, milliseconds?: number, minutes?: number, months?: number, quarters?: number, seconds?: number, weeks?: number, years?: number }) {
        this._setOption('minRange', value);
    }

    
    get placeholderHeight(): number {
        return this._getOption('placeholderHeight');
    }
    set placeholderHeight(value: number) {
        this._setOption('placeholderHeight', value);
    }

    
    get setTicksAtUnitBeginning(): boolean {
        return this._getOption('setTicksAtUnitBeginning');
    }
    set setTicksAtUnitBeginning(value: boolean) {
        this._setOption('setTicksAtUnitBeginning', value);
    }

    
    get showCustomBoundaryTicks(): boolean {
        return this._getOption('showCustomBoundaryTicks');
    }
    set showCustomBoundaryTicks(value: boolean) {
        this._setOption('showCustomBoundaryTicks', value);
    }

    
    get showMinorTicks(): boolean {
        return this._getOption('showMinorTicks');
    }
    set showMinorTicks(value: boolean) {
        this._setOption('showMinorTicks', value);
    }

    
    get singleWorkdays(): Array<Date|
        string|
        number> {
        return this._getOption('singleWorkdays');
    }
    set singleWorkdays(value: Array<Date|
        string|
        number>) {
        this._setOption('singleWorkdays', value);
    }

    
    get type(): string {
        return this._getOption('type');
    }
    set type(value: string) {
        this._setOption('type', value);
    }

    
    get useTicksAutoArrangement(): boolean {
        return this._getOption('useTicksAutoArrangement');
    }
    set useTicksAutoArrangement(value: boolean) {
        this._setOption('useTicksAutoArrangement', value);
    }

    
    get valueType(): string {
        return this._getOption('valueType');
    }
    set valueType(value: string) {
        this._setOption('valueType', value);
    }

    
    get workdaysOnly(): boolean {
        return this._getOption('workdaysOnly');
    }
    set workdaysOnly(value: boolean) {
        this._setOption('workdaysOnly', value);
    }

    
    get workWeek(): Array<number> {
        return this._getOption('workWeek');
    }
    set workWeek(value: Array<number>) {
        this._setOption('workWeek', value);
    }

    protected get _optionPath() {
        return 'scale';
    }


    
    get breaksChildren(): QueryList<DxiBreakComponent> {
        return this._getOption('breaks');
    }
    set breaksChildren(value) {
        this.setChildren('breaks', value);
    }

    constructor(  parentOptionHost: NestedOptionHost,
             optionHost: NestedOptionHost) {
        super();
        parentOptionHost.setNestedOption(this);
        optionHost.setHost(this, this._fullOptionPath.bind(this));
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'dxo-scale',
    template: '',
    styles: [''],
    providers: [NestedOptionHost]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: NestedOptionHost, decorators: [{ type: SkipSelf }, { type: Host }, ]},
{type: NestedOptionHost, decorators: [{ type: Host }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'allowDecimals': [{ type: Input },],
'customMinorTicks': [{ type: Input },],
'customTicks': [{ type: Input },],
'endValue': [{ type: Input },],
'hideFirstLabel': [{ type: Input },],
'hideFirstTick': [{ type: Input },],
'hideLastLabel': [{ type: Input },],
'hideLastTick': [{ type: Input },],
'label': [{ type: Input },],
'majorTick': [{ type: Input },],
'minorTick': [{ type: Input },],
'minorTickInterval': [{ type: Input },],
'orientation': [{ type: Input },],
'startValue': [{ type: Input },],
'tick': [{ type: Input },],
'tickInterval': [{ type: Input },],
'horizontalOrientation': [{ type: Input },],
'verticalOrientation': [{ type: Input },],
'breaks': [{ type: Input },],
'breakStyle': [{ type: Input },],
'categories': [{ type: Input },],
'endOnTick': [{ type: Input },],
'holidays': [{ type: Input },],
'logarithmBase': [{ type: Input },],
'majorTickInterval': [{ type: Input },],
'marker': [{ type: Input },],
'maxRange': [{ type: Input },],
'minorTickCount': [{ type: Input },],
'minRange': [{ type: Input },],
'placeholderHeight': [{ type: Input },],
'setTicksAtUnitBeginning': [{ type: Input },],
'showCustomBoundaryTicks': [{ type: Input },],
'showMinorTicks': [{ type: Input },],
'singleWorkdays': [{ type: Input },],
'type': [{ type: Input },],
'useTicksAutoArrangement': [{ type: Input },],
'valueType': [{ type: Input },],
'workdaysOnly': [{ type: Input },],
'workWeek': [{ type: Input },],
'breaksChildren': [{ type: ContentChildren, args: [forwardRef(() => DxiBreakComponent), ] },],
};
}


export class DxoScaleModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    DxoScaleComponent
  ],
  exports: [
    DxoScaleComponent
  ],
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
